// Format expertise into a more concise list
export const formatExpertise = (expertise: string[] | undefined): string => {
  if (!expertise || expertise.length === 0) return 'game development';
  return expertise.join(', ');
};

// Sort stages in specific order
export const sortStages = (stages: string[]) => {
  const order = { startup: 1, growth: 2, mature: 3 };
  return stages.sort(
    (a, b) =>
      (order[a.toLowerCase() as keyof typeof order] || 0) -
      (order[b.toLowerCase() as keyof typeof order] || 0)
  );
};

export const createMentorUrl = (mentorId: string): string => {
  return `https://gamementors.be/mentors/${mentorId}`;
};

export const createMentorMetaDescription = (
  name: string,
  expertise: string[] | undefined,
  shortDescription?: string
): string => {
  const expertiseStr = formatExpertise(expertise);
  return shortDescription
    ? `Connect with ${name}, ${shortDescription}. Get mentorship in ${expertiseStr} for your game studio.`
    : `Connect with ${name}, expert in ${expertiseStr}. Get personalized mentorship for your game development journey.`;
};
